"use client";

import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToProtectYourRoof() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235675" id="secure-your-communication" className="dark bg-background text-foreground relative py-20 md:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649121/img/topographic_pattern.png')] opacity-10 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-card-warm pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-serif text-[48px] leading-tight font-bold mb-8 text-foreground tracking-tighter">
            Join Our Expert Network
          </h2>

          <div className="mb-8">
            <Link to="mailto:talent@glyphicls.com" className="inline-block transition-transform duration-300 hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-sm">
              <span className="font-sans text-base leading-relaxed font-semibold text-primary tracking-tight">
                Join a Boutique Network of Ethical Experts
              </span>
            </Link>
          </div>

          <p className="font-sans text-base leading-relaxed text-foreground/80 mb-12 max-w-2xl mx-auto">
            We are looking for certified medical and legal interpreters who prioritize technical precision and operational excellence. Join GLYPHIC S.A.S. and work within a secure, professional environment dedicated to bridging language gaps with integrity.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mb-8">
            <Button asChild size="lg" className="w-full sm:w-auto text-base font-sans font-semibold h-14 px-8 shadow-lg shadow-primary/30 bg-primary hover:bg-primary/90 rounded-sm">
              
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base font-sans font-semibold h-14 px-8 border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-sm">
              <Link to="mailto:talent@glyphicls.com">
                <Mail className="mr-2 size-5" />
                Send us your credentials: talent@glyphicls.com
              </Link>
            </Button>
          </div>

          <div className="flex items-center justify-center gap-8 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
            
            
            
          </div>
        </div>
      </div>
    </section>;
}